import type { ComponentMode, SpecialOffer } from 'types';

interface State extends SpecialOffer {
  mode: ComponentMode;
  defaultTitle: string;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_SPECIAL_OFFER_DURATION';
      payload: Pick<typeof initialState, 'duration'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
